let isTracking = false;

document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    const codigo = urlParams.get('codigo');

    if (codigo && !isTracking) {
        document.getElementById('trackingCode').value = codigo;
        fetchTrackingInfo();
    }
});

async function fetchTrackingInfo() {
    if (isTracking) return;
    isTracking = true;

    const trackingCode = document.getElementById('trackingCode').value;

    if (trackingCode.length < 8) {
        alert('Insira um código válido.');
        isTracking = false;
        return;
    }

    const apiUrl = 'https://runtime.hyperflowapis.global/api/9T2jyo0Ke/api-rastreamento/rastrear';
    const container = document.getElementById('trackingInfo');

    container.style.display = 'block';
    container.innerHTML = `<p style="font-size:18px;text-align:center;">🔍 Rastreando...</p>`;

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ codigo: trackingCode })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        displayTrackingInfo(data);

    } catch (error) {
        console.error('Erro ao buscar informações de rastreamento:', error);
        container.innerHTML = `<p>Erro ao buscar informações de rastreamento. Por favor, tente novamente.</p>`;
    } finally {
        isTracking = false;
    }
}

function displayTrackingInfo(data) {
    const container = document.getElementById('trackingInfo');
    const historico = Array.isArray(data.historico) ? data.historico : [];

    /* ===== Nome amigável da transportadora ===== */
    let transportadoraLabel = data.transportadora || '-';

    if (data.transportadora === 'CorreiosByFrenet') {
        transportadoraLabel = 'Correios 🚛';
    } else if (data.transportadora === 'LoggiByFrenet') {
        transportadoraLabel = 'Loggi 🚛';
    }

    /* ===== Previsão (somente Loggi e Correios diretos) ===== */
    let previsaoHtml = '';
    if (
        data.previsao &&
        (data.transportadora === 'Loggi' || data.transportadora === 'Correios')
    ) {
        previsaoHtml = `
            <div style="margin-top:8px;">
                Previsão:
                <strong>${formatDateOnly(data.previsao)}</strong>
            </div>
        `;
    }

    /* ===== Mensagem especial Correios ===== */
    let mensagemCorreios = '';
    if (
        data.transportadora === 'Correios' &&
        historico.some(item =>
            item.descricao?.toLowerCase().includes('aguardando retirada')
        )
    ) {
        mensagemCorreios = `
            <div style="margin-top:20px;color:red;">
                <strong>
                    Clique <a href="https://rastreamento.correios.com.br/" target="_blank">aqui</a>
                    para verificar o local de retirada nos Correios.
                </strong>
            </div>
        `;
    }

    container.innerHTML = `
        <div style="font-size:18px;color:#0b3b3b;margin-bottom:10px;">
            Consulta de rastreamento do código <strong>${data.codigo || '-'}</strong>
        </div>

        <div>
            Transportadora:
            <strong>${transportadoraLabel}</strong>
        </div>

        ${previsaoHtml}
        ${mensagemCorreios}

        <div style="font-size:18px;color:#0b3b3b;margin-top:18px;">
            Histórico completo:
        </div>

        <ul id="historicoList"></ul>
        <div id="linkTransportadora" style="margin-top:20px;"></div>
    `;

    const historicoList = document.getElementById('historicoList');

    if (!historico.length) {
        historicoList.innerHTML = `<li>Por favor, clique no link abaixo para rastrear diretamente no site da transportadora.</li>`;
        renderLinkTransportadora(data.transportadora);
        return;
    }

    historicoList.innerHTML = historico.map(item => {
        let dataFormatada = '';
        let descricao = '';

        if (data.transportadora === 'Loggi') {
            dataFormatada = formatDate(item.status?.updatedTime);
            const loc = [item.location?.city, item.location?.state].filter(Boolean).join(', ');
            descricao = `${item.status?.highLevelStatus || ''}${loc ? `. ${loc}` : ''}`;

        } else if (data.transportadora === 'Correios') {
            dataFormatada = formatDateOnly(item.dtHrCriado);
            const loc = [item.unidade?.endereco?.cidade, item.unidade?.endereco?.uf].filter(Boolean).join(', ');
            descricao = `${item.descricao || ''}${loc ? `, ${loc}` : ''}`;

        } else if (
            data.transportadora === 'LoggiByFrenet' ||
            data.transportadora === 'CorreiosByFrenet'
        ) {
            const d = parseBRDateTime(item.EventDateTime);
            dataFormatada = d ? formatDateFromDate(d) : '';
            const { city, state } = parseCityState(item.EventLocation);
            const loc = [city, state].filter(Boolean).join(', ');
            descricao = `${item.EventDescription || ''}${loc ? `. ${loc}` : ''}`;

        } else {
            dataFormatada = formatDate(item.dataHora || item.updatedTime || item.dtHrCriado);
            descricao = item.ocorrencia || item.descricao || '';
        }

        return `<li>${dataFormatada} - ${descricao}</li>`;
    }).join('');

    renderLinkTransportadora(data.transportadora);
}

/* ===== Link da transportadora ===== */
function renderLinkTransportadora(transportadora) {
    const container = document.getElementById('linkTransportadora');
    let link = '';

    if (transportadora === 'Loggi' || transportadora === 'LoggiByFrenet') {
        link = 'https://app.loggi.com/rastreador/completo';

    } else if (transportadora === 'Correios' || transportadora === 'CorreiosByFrenet') {
        link = 'https://rastreamento.correios.com.br/';

    } else if (transportadora === 'Jadlog') {
        link = 'https://www.jadlog.com.br/jadlog/home';
    }

    if (link) {
        container.innerHTML = `
            <a href="${link}" target="_blank" style="font-weight:bold;color:#0b3b3b;">
                Clique aqui para rastrear no site da transportadora
            </a>
        `;
    }
}

/* ===== Helpers ===== */
function formatDate(dateTimeString) {
    const d = new Date(dateTimeString);
    if (isNaN(d)) return '';
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function formatDateOnly(dateTimeString) {
    const d = new Date(dateTimeString);
    if (isNaN(d)) return '';
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

function parseBRDateTime(str) {
    if (!str) return null;
    const [date, time = '00:00'] = str.split(' ');
    const [dd, mm, yyyy] = date.split('/').map(Number);
    const [hh, min] = time.split(':').map(Number);
    return new Date(yyyy, mm - 1, dd, hh || 0, min || 0);
}

function formatDateFromDate(d) {
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function parseCityState(str) {
    if (!str || str === '-') return { city: '', state: '' };
    const parts = str.split(/[-–—]/).map(s => s.trim());
    return { city: parts[0], state: parts[1] || '' };
}

function pad(n) {
    return String(n).padStart(2, '0');
}